import React, { useEffect, useState } from "react";
import "../../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
import Government_bg_img from "../../bg_images/I_government_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

const Servicecards = [
  {
    title: "Enhancing Citizen Services",
    text: " We improve accessibility, efficiency, and responsiveness of government services through digital platforms and user-friendly interfaces. ",
  },
  {
    title: " Modernizing Legacy Systems ",
    text: " We overcome outdated infrastructure and processes to improve efficiency, reduce costs, and enable innovation. ",
  },
  {
    title: "Ensuring Data Security and Compliance ",
    text: " Address increasing cyber threats and meet stringent regulatory requirements for data protection and privacy. ",
  },
  {
    title: " Improving Operational Efficiency ",
    text: " We streamline internal processes, automate tasks, and optimize resource allocation through smart IT solutions. ",
  },
  {
    title: " Driving Digital Transformation ",
    text: " We embrace digital technologies to enhance transparency, collaboration, and data-driven decision-making within government agencies. ",
  },
];

const Government = () => {
  const navigate = useNavigate();


   const [currentIndex, setCurrentIndex] = useState(0);
      const [visibleServicecards, setVisibleServicecards] = useState(3);
    
      
      useEffect(() => {
        const updateVisibleServicecards = () => {
          if (window.innerWidth <= 768) {
            setVisibleServicecards(1); 
          } else {
            setVisibleServicecards(3); 
          }
        };
    
        updateVisibleServicecards();
        window.addEventListener("resize", updateVisibleServicecards);
        return () =>
          window.removeEventListener("resize", updateVisibleServicecards);
      }, []);
    
      const handleNext = () => {
        if (currentIndex + visibleServicecards < Servicecards.length) {
          setCurrentIndex(currentIndex + 1);
        }
      };
    
      const handlePrev = () => {
        if (currentIndex > 0) {
          setCurrentIndex(currentIndex - 1);
        }
      };


  return (
    <div className="Industries">
      <div
        className="I_sec1"
        style={{ backgroundImage: `url(${Government_bg_img})` }}
      >
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" /> Government
        </h5>
        <h1>
          {" "}
          Powering Efficient and Secure Government Operations Through Innovative
          IT Solutions{" "}
        </h1>
        <p>
          We deliver tailored technology solutions that enhance efficiency,
          improve security, and drive better public services.
        </p>
        <button
          onClick={() => navigate("/services/ApplicationDevelopment")}
          className="S_sec1_btn1"
        >
          See Our Service Portfolio
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2> What We Offer Our Government Customers </h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/G_sec2_icon1.svg"
                alt=""
              />
              Secure and Compliant Infrastructure
            </h6>
            <p>
              Government-grade IT infrastructure designed for high security,
              compliance with regulations, and data protection.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/G_sec2_icon2.svg"
                alt=""
              />
              Digital Transformation Solutions
            </h6>
            <p>
              Modernize legacy systems and processes with digital tools to
              improve citizen engagement and streamline workflows.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/G_sec2_icon3.svg"
                alt=""
              />
              Cybersecurity and Data Protection
            </h6>
            <p>
              Comprehensive cybersecurity solutions to safeguard sensitive
              government data and critical infrastructure from evolving threats.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/G_sec2_icon4.svg"
                alt=""
              />
              Cloud Services for Government
            </h6>
            <p>
              Scalable and secure cloud solutions tailored to meet the unique
              needs of government agencies, enhancing agility and
              cost-efficiency.
            </p>
          </section>
        </section>
        <button onClick={() => navigate("/contact")} className="I_sec2_btn1">
          Schedule a free consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 3 */}

      <div className="S_carousel-container">
        <h2 className="S_carousel-title">
          Solving the Key Challenges in Government
        </h2>
        <div className="S_carousel-wrapper">
          <button
            className="arrow left-arrow"
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
          </button>

          <div className="S_carousel">
            <div
              className="S_carousel-track"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / visibleServicecards)
                }%)`,
              }}
            >
              {Servicecards.map((card, index) => (
                <div className="S_carousel-card" key={index}>
                  <h3>{card.title}</h3>
                  <div className="underline"></div>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            className="arrow right-arrow"
            onClick={handleNext}
            disabled={currentIndex + visibleServicecards >= Servicecards.length}
          >
            <MdOutlineKeyboardArrowRight className="S_rightArrow" />
          </button>
        </div>
      </div>

      {/* Section 4 */}

      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>
            How Arshil Is Enhancing Citizen Engagement And Operational
            Efficiency
          </h6>
          <p>
            We took our US-based FinFed Client from a promising proof of concept
            to a fully operational, cloud-native solution, using cloud
            tecbhnologies to ensure scalability and security at every level.
          </p>
          {/* <p>
            Read more about how we made this transition seamless and successful.
          </p> */}
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="../images/I_government_img.png"
            alt="government"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>Ready to Modernize Your Government Agency with Technology?</h4>
          <p>
            Let's discuss how our IT solutions can help you achieve your
            agency's goals and better serve your citizens.
          </p>
        </section>
        <section className="I_sec5_right">
          <button onClick={() => navigate("/contact")}>
            Request a Consultation
            <HiArrowNarrowRight className="I_sec5_arrow_right" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Government;
